module.exports = __webpack_public_path__ + "static/media/horus.55faeb6e.png";